export const projects = {
  adaptationProjectPicker: {
    adaptationProjectPickerModal: {
      chooseAProjectToUse: 'Choose a project to use Adaptation',
      createNewProject: 'Create new project',
      failedToLoadProjectsPlease: 'Failed to load projects. Please try again later.',
      noProjectsFound: 'No projects found.',
      noProjectsMatchYourSearch: 'No projects match your search.',
      search: 'Search',
      searchProjectsLabel: 'Search projects',
      selectAProject: 'Select a project',
    },
    selectProjectTable: {
      createdAt: 'Created at',
      open: 'Open',
      owner: 'Owner',
      projectTitle: 'Project title',
    },
    useAdaptationProjects: {
      untitledProject: 'Untitled project',
    },
  },
  addProjectContext: {
    projectContextPicker: {
      allTypes: 'All types',
      chooseAProjectToSee: 'Choose a project to see its briefs and library artifacts',
      filterByType: 'Filter by type',
      newestFirst: 'Newest first',
      noBriefsOrArtifactsIn: 'No briefs or artifacts in this project',
      search: 'Search',
      searchBriefsAndArtifacts: 'Search briefs and artifacts',
      type: 'Type',
    },
    projectSelectInline: {
      project: 'Project',
      searchProjects: 'Search projects',
      selectProject: 'Select project',
      untitledProject: 'Untitled project',
    },
  },
  approveAssetStep: {
    approvalTimeline: {
      anyoneWithRole: 'Anyone with the {{role}} role',
      approve: 'Approve',
      approvedBadge: 'Approved',
      approvedByName: 'Approved by {{name}}',
      cancel: 'Cancel',
      failedToApproveStep: 'Failed to approve step.',
      failedToOverrideStep: 'Failed to override step.',
      failedToUnapproveStep: 'Failed to unapprove step.',
      failedToUndoOverride: 'Failed to undo the override.',
      inProgressBadge: 'In progress',
      noReviewersAssigned: 'No reviewers assigned',
      overrideStep: 'Approve the {{step}} step as a manager',
      overrideThisStep: 'Override this step?',
      overriding: 'Overriding...',
      overridingClearsTheStep:
        'The step counts as approved straight away, whatever it asked for. Reviewers can no longer act on it, and the approvals they have already given are kept. Only a manager can undo this.',
      stepApproved: 'Step approved.',
      stepOverrideUndone: 'Override undone.',
      stepOverridden: 'Step overridden.',
      stepUnapproved: 'Step unapproved.',
      unapprove: 'Unapprove',
      unapproveStep: 'Unapprove the {{step}} step',
      unapproveThisStep: 'Unapprove this step?',
      unapproving: 'Unapproving...',
      unapprovingClearsOnlyThisStep:
        'This clears every approval on the step, not only the one you picked. Steps may be approved in any order, so the others are untouched.',
      unapprovingWillResetThisStep:
        'This clears every approval on the step, not only the one you picked, and resets all subsequent steps. Approvals on earlier steps are preserved.',
      undoOverrideForStep: 'Undo the override on the {{step}} step',
      undoOverrideThisStep: 'Undo this override?',
      undoingOverride: 'Undoing...',
      undoingOverrideResetsLaterSteps:
        'The step goes back to the approvals its reviewers actually gave, and they can act on it again. Every step after it is reset.',
      undoingOverrideRestoresReviewers:
        'The step goes back to the approvals its reviewers actually gave, and they can act on it again.',
      unknown: 'Unknown',
      yesOverride: 'Yes, override',
      yesUnapprove: 'Yes, unapprove',
      yesUndoOverride: 'Yes, undo',
    },
    timelineUtils: {
      allMustApprove: 'All must approve',
      anyOneApproves: 'Any one approves',
      anyOrder: 'Any order',
      atLeastNApprove: 'At least {{count}} approve',
      inOrder: 'In order',
      ruleAndProgress: '{{rule}} · {{approved}}/{{total}} approved',
      stepsApproved_one: '{{approved}} of {{count}} step approved',
      stepsApproved_other: '{{approved}} of {{count}} steps approved',
      thresholdAndWaiting: '{{threshold}} · {{waiting}}',
      waitingForEarlierSteps: 'Waiting for earlier steps',
      waitingOnStep: 'Waiting on step {{position}}',
    },
  },
  assetApprovalChain: {
    chainProgressUtils: {
      stepsApproved: '{{approved}}/{{total}}',
      stepsApprovedAnnouncement_one: '{{approved}} of {{count}} step approved',
      stepsApprovedAnnouncement_other: '{{approved}} of {{count}} steps approved',
    },
    fileApprovalProgress: {
      approvalChainName: 'Approval chain: {{name}}',
    },
    fileProgressUtils: {
      nOfMNeeded: '{{approved}} of {{required}} needed',
      stepsApproved: '{{approved}}/{{total}}',
      stepsAwaiting: 'awaiting {{stepName}}',
    },
  },
  assignAssetApprovalChain: {
    assetApprovalChainControl: {
      editPermissionOnly: 'Manager only',
      applyingNamedApprovalChainClears:
        'Applying “{{name}}” clears every approval collected so far. Approvers start over.',
      clear: 'Clear',
      changeApprovalChain: 'Change approval chain?',
      changingApprovalChain: 'Changing...',
      confirmChangeApprovalChain: 'Change chain',
      confirmRemoveApprovalChain: 'Remove chain',
      failedToAssignApprovalChain: 'Failed to assign approval chain.',
      failedToRemoveApprovalChain: 'Failed to remove approval chain.',
      noApprovalChain: 'No approval chain',
      removeApprovalChain: 'Remove approval chain?',
      thisRemovesTheApprovalChainFrom:
        'This removes the approval chain from this asset. If the chain had fully approved it, the asset goes back to To review.',
      thisRemovesNamedApprovalChainFrom:
        'Removing “{{name}}” from this asset clears every approval collected so far. If the chain had fully approved it, the asset goes back to To review.',
      approvalChainAssigned: 'Approval chain assigned.',
      approvalChainRemoved: 'Approval chain removed.',
    },
    bulkAssignApprovalChainDialog: {
      assetsThatAlreadyHaveA: 'Assets that already have an approval chain will be skipped.',
      assetsWithAnApprovalChainWill:
        'Assets with an approval chain will be reassigned to this one.',
      assignedToAssets_one: 'Assigned to {{count}} asset.',
      assignedToAssets_other: 'Assigned to {{count}} assets.',
      assignedToAssetsSkipped_one:
        'Assigned to {{count}} asset; {{skipped}} skipped (already assigned).',
      assignedToAssetsSkipped_other:
        'Assigned to {{count}} assets; {{skipped}} skipped (already assigned).',
      assignApprovalChain: 'Assign approval chain',
      assignApprovalChainToAssets_one: 'Assign approval chain to {{count}} asset',
      assignApprovalChainToAssets_other: 'Assign approval chain to {{count}} assets',
      overrideClearsApprovals:
        'Every approval collected on the chains being replaced is cleared. Approvers start over.',
      cancel: 'Cancel',
      failedToAssignApprovalChain: 'Failed to assign approval chain.',
      overrideExistingAssignments: 'Override existing assignments',
      selectAnApprovalChain: 'Select an approval chain',
      thisProjectHasNoApprovalChains: 'This project has no approval chains yet.',
      approvalChain: 'Approval chain',
    },
    bulkRemoveApprovalChainDialog: {
      approvalChain: 'Approval chain',
      approvedAssetsReturnToReview:
        'Any asset this chain had fully approved goes back to To review.',
      cancel: 'Cancel',
      chainOnAssets_one: '{{name}} ({{count}} asset)',
      chainOnAssets_other: '{{name}} ({{count}} assets)',
      failedToRemoveApprovalChain: 'Failed to remove approval chain.',
      noneOfTheSelectedAssetsHave: 'None of the selected assets have an approval chain.',
      remainingAreSkipped_one: '{{count}} selected asset is not on this chain and is left alone.',
      remainingAreSkipped_other:
        '{{count}} selected assets are not on this chain and are left alone.',
      removeApprovalChain: 'Remove approval chain',
      removedFromAssets_one: 'Removed from {{count}} asset.',
      removedFromAssets_other: 'Removed from {{count}} assets.',
      removedFromAssetsSkipped_one: 'Removed from {{count}} asset; {{skipped}} skipped.',
      removedFromAssetsSkipped_other: 'Removed from {{count}} assets; {{skipped}} skipped.',
      selectAnApprovalChain: 'Select an approval chain',
      thisRemovesNamedApprovalChainFrom_one: 'This removes {{name}} from {{count}} asset.',
      thisRemovesNamedApprovalChainFrom_other: 'This removes {{name}} from {{count}} assets.',
    },
    approvalChainStepUtils: {
      anyOneApprover: 'Any one approver',
    },
  },
  bulkApproveAssets: {
    bulkUnapproveDialog: {
      cancel: 'Cancel',
      failedToUnapproveAssets: 'Failed to unapprove assets.',
      unapproveAssets_one: 'Unapprove {{count}} asset?',
      unapproveAssets_other: 'Unapprove {{count}} assets?',
      unapprovingStepsBack_one:
        'Unapproving steps back the selected asset by one step, resetting the most recently approved step and any steps after it. Approvals on earlier steps are preserved. An asset with nothing approved yet is skipped.',
      unapprovingStepsBack_other:
        'Unapproving steps back the selected assets by one step, resetting the most recently approved step and any steps after it. Approvals on earlier steps are preserved. Assets with nothing approved yet are skipped.',
      yesUnapprove: 'Yes, unapprove',
    },
    summarizeResults: {
      approvedHead_one: '{{count}} asset approved',
      approvedHead_other: '{{count}} assets approved',
      summary: '{{head}}.',
      summaryWithSkipped: '{{head}}; {{skippedCount}} skipped{{reason}}.',
      unapprovedHead_one: '{{count}} asset unapproved',
      unapprovedHead_other: '{{count}} assets unapproved',
      withReason: ' ({{reason}})',
    },
  },
  commentOnFile: {
    annotatedCommentInput: {
      attachmentsUnavailable: 'Attachments are unavailable until this file is fully loaded.',
    },
    annotatedCommentThread: {
      editYourComment: 'Edit your comment...',
      leaveYourReply: 'Leave your reply',
      save: 'Save',
      thisWillPermanentlyDeleteThe:
        'This will permanently delete the comment, any replies and related annotations. This action cannot be undone.',
    },
    annotationToolbar: {
      actions: 'Actions',
      clear: 'Clear',
      color: 'Color',
      redo: 'Redo',
      tool: 'Tool',
      undo: 'Undo',
    },
    annotationToolButton: {
      annotationTool: 'Annotation tool',
      openAnnotationTools: 'Open annotation tools',
      toolDeactivate: '{{tool}} — deactivate',
    },
    briefCommentThread: {
      editYourComment: 'Edit your comment...',
      leaveYourReply: 'Leave your reply',
      save: 'Save',
      thisWillPermanentlyDeleteThe:
        'This will permanently delete the comment, any replies and related annotations. This action cannot be undone.',
    },
    colorRow: {
      strokeColor: 'Stroke color {{color}}',
    },
    commentDeleteDialog: {
      thisActionCannotBeUndone: 'This action cannot be undone.',
    },
    commentInputActionsBar: {
      attachFile: 'Attach file',
      cancel: 'Cancel',
      clearAnnotations: 'Clear annotations',
      redoAnnotation: 'Redo annotation',
      undoAnnotation: 'Undo annotation',
    },
    commentReplies: {
      loadingReplies: 'Loading replies…',
    },
    commentsPanel: {
      hideResolvedComments: 'Hide resolved comments',
      loadMoreComments: 'Load more comments',
      resolvedComments: 'Resolved comments',
      showResolvedComments: 'Show resolved comments',
      sortBy: 'Sort by',
      sortNewest: 'Newest',
      sortOldest: 'Oldest',
      sortRootComments: 'Sort root comments',
    },
    commentsStore: {
      black: 'Black',
      blue: 'Blue',
      green: 'Green',
      red: 'Red',
      unableToPostComment: 'Unable to post comment: file version not loaded.',
      yellow: 'Yellow',
    },
    formatRelativeTime: {
      daysAgo: '{{days}}d ago',
      hoursAgo: '{{hours}}h ago',
      justNow: 'just now',
      minutesAgo: '{{minutes}}m ago',
      monthsAgo: '{{months}}mo ago',
      weeksAgo: '{{weeks}}w ago',
      yearsAgo: '{{years}}y ago',
    },
    highlightCommentComposerChip: {
      commentWillBeAnchoredTo: 'Comment will be anchored to the selected text highlight',
      highlight: 'Highlight',
      removeHighlight: 'Remove highlight',
    },
    sectionCommentComposerChip: {
      commentWillBeAnchoredTo: 'Comment will be anchored to the {{section}} section',
      removeSection: 'Remove section',
    },
    toolSpecs: {
      arrow: 'Arrow',
      circle: 'Circle',
      draw: 'Draw',
      square: 'Square',
      textHighlight: 'Text highlight',
    },
    useCreateComment: {
      failedToPostComment: 'Failed to post comment. Please try again.',
    },
    useDeleteComment: {
      commentDeleted: 'Comment deleted',
      failedToDeleteComment: 'Failed to delete comment. Please try again.',
    },
    useResolveComment: {
      failedToUpdateCommentStatus: 'Failed to update comment status. Please try again.',
    },
    useThreadActions: {
      couldNotCopyLink: 'Could not copy link',
      linkCopiedToClipboard: 'Link copied to clipboard',
    },
    useUpdateComment: {
      failedToUpdateComment: 'Failed to update comment. Please try again.',
    },
    versionSelectorPopover: {
      compare: 'Compare',
      uploading: 'Uploading…',
      uploadNewVersion: 'Upload new version',
      version: 'Version {{versionLabel}}',
      versioning: 'Versioning',
      versions: 'Versions',
    },
    videoCommentComposerTimestampChip: {
      annotationTimestamp: 'Annotation timestamp {{timestamp}}',
      annotationWillUseTimestamp: 'Annotation will use timestamp {{timestamp}}',
    },
  },
  createProject: {
    reviewDetailsStep: {
      addDates: 'Add dates',
      addProjectDescription: 'Add project description',
      addProjectTitle: 'Add project title',
      audiences: 'Audiences',
      deadline: 'Deadline',
      duration_one: 'Duration: {{count}} day',
      duration_other: 'Duration: {{count}} days',
      market: 'Market',
      projectDescription: 'Project description',
      projectStatus: 'Project status',
      projectTitle: 'Project title',
      projectType: 'Project type',
      removePersona: 'Remove {{label}}',
      searchForAudiences: 'Search for audiences',
      selectAProjectType: 'Select a project type',
      selectMarket: 'Select market',
      selectStatus: 'Select status',
      startDate: 'Start date',
      tags: 'Tags',
      tellUsAboutYourProject: 'Tell us about your project',
      typeAndHitEnterTo: 'Type and hit enter to add tags',
    },
    uploadDocumentsStep: {
      doYouWantToBuild: 'Do you want to build your project automatically?',
      dropDocumentsHere: 'Drop documents here',
      dropInADocumentBrief:
        "Drop in a document (brief and etc) and we'll pull out the key details to get you started",
      filesAlreadyAdded: '{{fileCount}} file(s) already added',
      filesExceededThe100MbSize: '{{fileCount}} file(s) exceeded the 100MB size limit',
      formatImages: 'Images',
      formatVideos: 'Videos',
      maxSizeIs100Mb: 'Max size is 100 MB',
    },
    useCreateProjectWizard: {
      aProjectWithThisTitle:
        'A project with this title already exists. Please choose a different title.',
      failedToProceed: 'Failed to proceed',
      somethingWentWrongWhileCreating:
        'Something went wrong while creating your project. Please try again.',
      weCouldNotAnalyzeYour:
        'We could not analyze your documents. You can fill in the details manually.',
      youCanNowStartBriefing: 'You can now start briefing and production',
      yourProjectHasBeenCreated: 'Your project has been created',
    },
  },
  dashboard: {
    campaign: 'Campaign',
    chooseACampaign: 'Choose a campaign…',
    generateDashboard: 'Generate dashboard',
    noCampaignsLinked: 'Link a campaign to this project to generate a dashboard.',
    noDeliveryForCampaign: 'This campaign has no delivery to chart.',
    couldNotGenerate: 'Could not generate the dashboard. Try again.',
  },
  deliveryJobCreate: {
    tabPicker: {
      whichTabs: 'Which tabs hold the plan?',
      description:
        'This workbook has several tabs. The ones that look like the live plan are ticked; hidden tabs are usually retired versions.',
      rowsAndColumns: '{{rows}} rows, {{columns}} columns',
      showHiddenTabs_one: 'Show {{count}} hidden tab',
      showHiddenTabs_other: 'Show {{count}} hidden tabs',
      hideHiddenTabs_one: 'Hide {{count}} hidden tab',
      hideHiddenTabs_other: 'Hide {{count}} hidden tabs',
      atMost: 'A read takes up to {{count}} tabs. Untick one to pick another.',
      cancel: 'Not now',
      queueing: 'Queueing…',
      readTabs_one: 'Read {{count}} tab',
      readTabs_other: 'Read {{count}} tabs',
    },
    newJobDialog: {
      addMoreFiles: 'Add more files',
      aFileInTheMonksTemplate:
        'A file in the Monks media plan template parses without any column mapping. Anything else is matched by column name, and you confirm the result on the next screen. To send the creative images too, zip them up with the plan and name each one in its Image file column.',
      aFileInTheMonksTemplateWithCreatives:
        "A file in the Monks media plan template parses without any column mapping. Anything else is matched by column name, and you confirm the result on the next screen. Creatives can come with the plan: drop them alongside it, and name each one in the plan's Image file column so we know which row it belongs to.",
      cancel: 'Cancel',
      chooseAFile: 'Choose a file',
      chooseFiles: 'Choose files',
      creativesShareAName:
        'More than one creative is called {{fileNames}}. A creative is matched to a plan row by its file name, so rename all but one before uploading.',
      creativesWithCount: 'Creatives ({{count}})',
      dropAnXlsxCsvOrZipHere: 'Drop an XLSX, CSV or ZIP here, or',
      dropAnXlsxOrCsvPlan:
        'Drop an .xlsx or .csv plan, or a .zip holding one alongside its images.',
      dropThePlanAndItsCreativesHere: 'Drop the plan and its creatives here, or',
      files: 'Files',
      keepOnlyOnePlan:
        'More than one plan in this selection: {{fileNames}}. Keep the one this job is for and remove the rest.',
      newJob: 'New job',
      parseFile: 'Parse file',
      parsing: 'Parsing…',
      uploadingPercent: 'Uploading {{percent}}%',
      plan: 'Plan',
      planIsMissing: 'No plan in this selection. Add the .xlsx or .csv these creatives belong to.',
      removeFile: 'Remove file',
      sourceFile: 'Source file',
      thatFileIsNotAMediaPlan: 'That file is not a media plan.',
      thatFileIsOverItsLimit: '{{fileName}} is larger than the {{limit}} limit.',
      thatFileIsOverTheSizeLimit:
        'That file is over the size limit: 10 MB for a plan, 100 MB for a zip.',
      theZipGoesOnItsOwn:
        'A .zip already carries its own creatives. Drop it on its own, or drop the plan and the creatives loose.',
      thoseAreNotCreatives:
        'We cannot use {{fileNames}}. A plan is an .xlsx or .csv; a creative is a JPG, PNG, GIF, WEBP, MP4, MOV or WEBM.',
      title: 'Title',
      titlePlaceholder: 'Q3 Always On — NL launch',
      uploadTheMediaPlan:
        'Upload the media plan. We parse it into everything it would create or change on each platform, and you check it before anything is published.',
    },
  },
  deliveryJobGrid: {
    deliveryJobEmptyState: {
      clearFilters: 'Clear filters',
      couldNotLoadJobs: "Couldn't load jobs",
      jobs: 'Jobs',
      jobsAreStillThere:
        'Something went wrong fetching this project’s jobs. Nothing has been lost, so try again in a moment.',
      newJob: 'New job',
      noMatchingJobs: 'No matching jobs',
      preparing: 'Preparing…',
      template: 'Template',
      tryADifferentSearch: 'Try a different search or filter.',
      tryAgain: 'Try again',
      uploadAMediaPlan:
        'Upload a media plan and we will parse it into everything it would create or change on each platform, for you to check before anything is published.',
    },
    deliveryJobGrid: {
      actions: 'Actions',
      adCount_one: '{{count}} ad',
      adCount_other: '{{count}} ads',
      contents: 'Contents',
      downloadFile: 'Download {{fileName}}',
      job: 'Job',
      lastUpdated: 'Last updated',
      platforms: 'Platforms',
      source: 'Source',
      status: 'Status',
    },
    deliveryJobRowActions: {
      actionsFor: 'Actions for {{title}}',
      delete: 'Delete',
    },
    deliveryJobToolbar: {
      allPlatforms: 'All platforms',
      allStatuses: 'All statuses',
      newJob: 'New job',
      platform: 'Platform',
      preparing: 'Preparing…',
      searchJobs: 'Search jobs',
      searchJobsLabel: 'Search delivery jobs',
      status: 'Status',
      template: 'Template',
    },
    filters: {
      failed: 'Failed',
      needsWork: 'Needs work',
      published: 'Published',
    },
  },
  deliveryJobReview: {
    columnResizeHandle: {
      dragToResize: 'Drag to resize, double-click to reset',
    },
    creativePreviewDialog: {
      addAFile: 'Add an image or video',
      addALogo: 'Add a logo',
      couldNotBeLoaded:
        '"{{named}}" could not be loaded. Something went wrong fetching it, so re-uploading will not help.',
      couldNotChangeTheFile: 'Could not change the file.',
      detailJoin: ' · ',
      done: 'Done',
      fileAttached: 'File attached.',
      fileRemoved: 'File removed.',
      fileTooLarge: '"{{named}}" is {{size}} MB. Creatives have to be under {{limit}}.',
      loading: 'Loading…',
      logo: 'Logo',
      noAssetYet:
        'No image or video on this creative yet. The ad will run on whatever the link renders.',
      noCreativeNamedInTheFile: 'No creative named in the file',
      noLogoYet: 'No logo yet. A video ad is refused without one.',
      notAmongUploadedFiles: '"{{named}}" was not among the files uploaded with this plan.',
      playsYouTubeVideo: 'Plays this video from YouTube as it is, with nothing uploaded.',
      remove: 'Remove',
      replaceFile: 'Replace image or video',
      replaceLogo: 'Replace logo',
      uploading: 'Uploading…',
      videoCannotBePlayed: '"{{named}}" could not be played here. This browser cannot decode it.',
    },
    jobHistoryPanel: {
      action: {
        accountBound: 'Account bound',
        advisoryDismissed: 'Advisory dismissed',
        findingsCleared: 'Findings cleared',
        findingWaived: 'Finding waived',
        planReImported: 'Plan re-imported',
        preflightRun: 'Pre-flight run',
        published: 'Published',
        rowEdited: 'Row edited',
      },
      actionCount_one: '{{count}} action',
      actionCount_other: '{{count}} actions',
      advisory: '{{count}} advisory',
      aRow: 'a row',
      closeHistory: 'Close history',
      history: 'History',
      listJoin: ', ',
      nameWithFields: '{{name}}: {{fields}}',
      nothingHasHappenedToThisJob: 'Nothing has happened to this job yet.',
      toCheck: '{{count}} to check',
      toFix: '{{count}} to fix',
    },
    jobIssuesPanel: {
      andToCheck: ', {{count}} to check',
      closeIssues: 'Close issues',
      forInformation: '{{count}} for information',
      group: {
        advice: 'For information',
        error: 'To fix',
        warning: 'To check',
      },
      groupHeading: '{{heading}} · {{count}}',
      issues: 'Issues',
      issuesInThisSheet: 'Issues in this sheet',
      linking: 'Linking…',
      linkToExisting: 'Link to existing',
      nothingToFixOnThisPlatform: 'Nothing to fix on this platform.',
      platformSuffix: ' · platform',
      reference: 'Reference',
      reportedByThePlatform: 'Reported by the platform',
      toFix: '{{count}} to fix',
    },
    jobNodeDrawer: {
      commaSeparated: 'Comma separated',
      edited: 'Edited',
      id: 'ID {{id}}',
      listJoin: ', ',
      objectDetails: 'Object details',
      reCheckNeededSuffix: ' (re-check needed)',
      row: 'Row {{rows}}',
      toFix: '{{count}} to fix',
      untitled: 'Untitled',
    },
    jobPlatformPanel: {
      adding: 'Adding…',
      addRow: 'Add row',
      clientsCouldNotLoad: 'Could not load the client accounts.',
      count: {
        forInformation: '{{count}} for information',
        new: '{{count}} new',
        unchanged: '{{count}} unchanged',
        updated: '{{count}} updated',
      },
      couldNotAddARow: 'Could not add a row. Try again.',
      couldNotLinkThisRow: 'Could not link this row. Re-run pre-flight and try again.',
      flat: 'Flat',
      forClient: 'for client',
      hierarchical: 'Hierarchical',
      linked: 'Linked. Publishing will change the existing object rather than making a second.',
      loading: 'Loading…',
      noAccountConnected: 'No {{platform}} account is connected in Knowledge Hub.',
      noDryRun:
        '{{platform}} cannot check a plan before it is published. Our own rules are the only guard, and publishing writes straight to the advertiser.',
      nothingCanBeChecked: 'Nothing can be checked against {{platform}} or published until it is.',
      noPage: 'No page',
      noPageDetail:
        'These credentials can see no Facebook Page, so no creative can be created. Assign one to the same system user that holds this ad account.',
      publishingAs: 'publishing as',
      publishingFailing:
        'The last check against {{platform}} failed. Publishing may still work — this is what it said.',
      publishingInto: 'Publishing into',
      reconnect: 'Reconnect',
      reportingFailing:
        'Delivery reporting from {{platform}} is failing. Publishing is unaffected.',
      retryClients: 'Retry',
      searchClients: 'Search client accounts',
      selectAClient: 'Choose a client account',
      selectAnAdAccount: 'Select an ad account',
      selectAPage: 'Select a page',
    },
    jobPlatformTable: {
      alreadyPublishedReadOnly:
        'Already published, so this row is read-only here. Change it where it is running.',
      alsoOnPlatform: 'Also on platform',
      alsoOnPlatformDetail:
        'A row with this name is already on the platform. Publishing creates a second one — open the findings to link this row to it instead.',
      change: 'Change',
      collapse: 'Collapse',
      details: 'Details',
      expand: 'Expand',
      issues: 'Issues',
      issuesHere: '{{count}} issues here',
      leafCount: '{{count}} {{noun}}',
      live: 'Live',
      openLevelSettings: 'Open {{level}} settings',
      preview: 'Preview',
      previewCreativeFor: 'Preview creative for {{name}}',
      row: 'Row',
      thisAd: 'this ad',
      untitled: 'Untitled',
    },
    publishActions: {
      checking: 'Checking…',
      checkingWithThePlatform: 'Checking with the platform…',
      clearFindings: 'Clear findings',
      clearing: 'Clearing…',
      history: 'History',
      publish: 'Publish',
      publishing: 'Publishing…',
      reRunPreflight: 'Re-run pre-flight',
      runPreflight: 'Run pre-flight',
      uploadingCreatives_one: 'Uploading {{count}} creative…',
      uploadingCreatives_other: 'Uploading {{count}} creatives…',
    },
    publishGate: {
      detail: {
        checking: 'Checking every field against each platform…',
        checksPassed: 'All checks passed. Everything below goes out in one push.',
        checksPassedUnchecked:
          'Our own rules passed, but {{where}} cannot check a plan before it is published, so nothing here has seen it.',
        clientsNeeded: 'Choose a client account for {{where}}, next to Publishing into.',
        fieldsNeedFixing_one: '{{count}} field needs fixing on {{where}}.',
        fieldsNeedFixing_other: '{{count}} fields need fixing on {{where}}.',
        noChanges: 'Nothing in this file would change on the platform.',
        preflightNotRun: 'Run pre-flight to check this plan before publishing.',
        published:
          'This job is published and nothing has changed since. Edit a row to send an update.',
        recheckNeeded: 'Edited since the last check — run pre-flight again.',
        unboundAccounts: 'No ad account selected for {{where}}.',
      },
      label: {
        checking: 'Checking…',
        checksPassed: 'Checks passed',
        noAdAccount: 'No ad account',
        noClient: 'No client',
        nothingToPublish: 'Nothing to publish',
        preflightNotRun: 'Pre-flight not run',
        published: 'Published',
        recheckNeeded: 'Re-check needed',
        toFix: '{{count}} to fix',
      },
      platformJoin: ' and ',
    },
    publishConfirmDialog: {
      cancel: 'Cancel',
      detail_one:
        'This creates 1 object on the ad accounts below and it can start spending straight away. Nothing here can undo it: the plan stays editable until you publish, the campaigns do not.',
      detail_other:
        'This creates {{count}} objects on the ad accounts below and they can start spending straight away. Nothing here can undo it: the plan stays editable until you publish, the campaigns do not.',
      noAccountNamed: 'No account named',
      notChecked:
        '{{platform}} cannot check a plan before it is published, so nothing has seen this one but our own rules. It writes straight to the advertiser.',
      publish: 'Publish',
      publishing: 'Publishing…',
      title_one: 'Publish 1 ad?',
      title_other: 'Publish {{count}} ads?',
    },
    publishReportDialog: {
      checking: 'Checking…',
      checkWhatLanded: 'Check what landed',
      count: {
        created: '{{count}} created',
        failed: '{{count}} failed',
        skipped: '{{count}} skipped',
        unchanged: '{{count}} unchanged',
        updated: '{{count}} updated',
      },
      creative: 'Creative',
      delivery: {
        draft: 'Draft',
        ended: 'Ended',
        inReview: 'In review',
        livePaused: 'Live, paused',
        notReported: 'Not reported',
        refused: 'Refused',
        serving: 'Serving',
      },
      deliveryCount: {
        inReview: '{{count}} in review',
        live: '{{count}} live',
        refused: '{{count}} refused',
      },
      done: 'Done',
      onThePlatform: 'On the platform: {{counts}}',
      outcome: {
        created: 'Created',
        failed: 'Failed',
        noChange: 'No change',
        skipped: 'Skipped',
        updated: 'Updated',
      },
      title: {
        nothingWasPublished: 'Nothing was published',
        published: 'Published',
        publishedInPart: 'Published in part',
      },
    },
    rightDrawer: {
      close: 'Close',
    },
  },
  editProject: {
    editProjectFormFields: {
      removeMarket: 'Remove {{market}}',
      removePersona: 'Remove {{label}}',
      removeTag: 'Remove {{tag}}',
      addDates: 'Add dates',
      addProjectDescription: 'Add project description',
      addProjectTitle: 'Add project title',
      audiences: 'Audiences',
      deadline: 'Deadline',
      duration_one: 'Duration: {{count}} day',
      duration_other: 'Duration: {{count}} days',
      market: 'Market',
      noResults: 'No results.',
      projectDescription: 'Project description',
      projectStatus: 'Project status',
      projectTitle: 'Project title',
      projectType: 'Project type',
      searchForAudiences: 'Search for audiences',
      selectAProjectType: 'Select a project type',
      selectMarket: 'Select market',
      selectStatus: 'Select status',
      startDate: 'Start date',
      tags: 'Tags',
      typeAndHitEnterTo: 'Type and hit enter to add tags',
    },
    editProjectModal: {
      cancel: 'Cancel',
      editProject: 'Edit project',
      saveChanges: 'Save changes',
    },
    quickEditProjectModal: {
      removeTag: 'Remove {{tag}}',
      cancel: 'Cancel',
      editProject: 'Edit project',
      enterTags: 'Enter tags',
      enterTheProjectName: 'Enter the project name…',
      failedToUpdateProject: 'Failed to update project.',
      nameIsTooLong: 'Name is too long',
      noResults: 'No results.',
      projectName: 'Project name',
      projectNameIsRequired: 'Project name is required',
      save: 'Save',
      tagMaxLength: 'Tag must be {{max}} characters or fewer',
      tags: 'Tags',
    },
    useEditProjectForm: {
      projectUpdatedSuccessfully: 'Project updated successfully',
      somethingWentWrongWhileUpdating:
        'Something went wrong while updating your project. Please try again.',
    },
  },
  manageProjectArtifacts: {
    useAttachArtifacts: {
      artifactsAdded: 'Artifacts added',
      failedToAddArtifacts: 'Failed to add artifacts',
    },
    useUploadArtifacts: {
      artifactsAdded_one: '{{count}} artifact added',
      artifactsAdded_other: '{{count}} artifacts added',
      uploadsFailed_one: '{{count}} upload failed',
      uploadsFailed_other: '{{count}} uploads failed',
    },
  },
  manageProjectFiles: {
    editFileTagsModal: {
      cancel: 'Cancel',
      editTags: 'Edit tags',
      enterTags: 'Enter tags',
      failedToUpdateTags: 'Failed to update tags.',
      noResults: 'No results.',
      removeTag: 'Remove {{tag}}',
      save: 'Save',
      tagMaxLength: 'Tag must be {{max}} characters or fewer',
      tags: 'Tags',
      tagsUpdated: 'Tags updated.',
    },
    renameFileModal: {
      cancel: 'Cancel',
      enterTheFileName: 'Enter the file name…',
      failedToRenameFile: 'Failed to rename file.',
      fileName: 'File name',
      fileRenamed: 'File renamed.',
      renameFile: 'Rename file',
      save: 'Save',
    },
  },
  manageProjectFolders: {
    createFolderModal: {
      couldNotLoadTheProjectBriefs: 'Could not load the project briefs',
      linkedBrief: 'Linked brief',
      noBrief: 'No brief',
      noReadyBriefsInThisProject: 'No ready briefs in this project',
      removeTag: 'Remove {{tag}}',
      cancel: 'Cancel',
      createFolder: 'Create folder',
      createNewFolder: 'Create new folder',
      createNewSubfolder: 'Create new subfolder',
      createSubfolder: 'Create subfolder',
      editFolder: 'Edit folder',
      enterTags: 'Enter tags',
      enterTheFolderName: 'Enter the folder name…',
      failedToCreateFolder: 'Failed to create folder.',
      failedToUpdateFolder: 'Failed to update folder.',
      folderName: 'Folder name',
      folderNameIsRequired: 'Folder name is required',
      nameIsTooLong: 'Name is too long',
      noResults: 'No results.',
      save: 'Save',
      tagMaxLength: 'Tag must be {{max}} characters or fewer',
      tags: 'Tags',
    },
    folderBriefBadge: {
      addBrief: 'Add brief',
      openBrief: 'Open brief {{title}}',
    },
    useDownloadFolder: {
      downloadFailedTryAgain: 'Download failed. Try again.',
    },
    useSetFolderThumbnail: {
      couldNotUpdateThumbnail: 'Could not update thumbnail.',
      folderThumbnailUpdated: 'Folder thumbnail updated.',
    },
    useSetFolderApprovalChain: {
      approvalChainCleared: 'Approval chain cleared for new uploads.',
      approvalChainSet: 'Approval chain set for new uploads.',
      couldNotSetApprovalChain: 'Could not set the approval chain.',
    },
  },
  manageProjectMembers: {
    approvalChainImpactNotice: {
      couldNotCheck: "Couldn't check this change against the project's approval chains.",
      stepApprovers_one: '{{chain}}: {{step}} would have {{available}} of {{count}} approver',
      stepApprovers_other: '{{chain}}: {{step}} would have {{available}} of {{count}} approvers',
      stepsLeftShort: 'Some approval steps would be left without enough approvers',
    },
    addMembersSection: {
      add: 'Add',
      addMembers: 'Add members',
      removeUser: 'Remove {{name}}',
    },
    manageMembersModal: {
      cancel: 'Cancel',
      peopleWithAccess: 'People with access',
      save: 'Save',
      saving: 'Saving...',
    },
    projectMembersModal: {
      projectMembers: 'Project members',
      projectMembersUpdated: 'Project members updated.',
    },
    useUpdateProjectMembers: {
      cannotAssignRole:
        "You can't assign {{role}}: it includes permissions you don't have. An Organization Admin can assign it.",
      failedToUpdateProjectMembers: 'Failed to update project members. Please try again.',
    },
  },
  mediaCampaign: {
    channel: {
      display: 'Display',
      programmatic: 'Programmatic',
      search: 'Search',
      social: 'Social',
      video: 'Video',
    },
    connectorAdvice: {
      disconnected: 'This account has been disconnected. Reconnect it in Knowledge Hub.',
      error:
        'Something failed on this account recently — often its reporting, which does not stop a publish. Try it, and reconnect in Knowledge Hub if it fails.',
      expired: "This account's access has expired. Reconnect it in Knowledge Hub.",
      pending: 'This account has not finished connecting. Complete it in Knowledge Hub.',
    },
    connectorHealth: {
      connected: 'Connected',
      disconnected: 'Disconnected',
      error: 'Not responding',
      expired: 'Access expired',
      pending: 'Finishing setup',
    },
    publishFailedWithoutReason: 'The platform refused this row and gave no reason.',
    fileTypeNotAccepted: '{{fileName}} is not a file a platform will take.',
    fileUploadFailed: '{{fileName}} could not be uploaded.',
    jobStatus: {
      failed: 'Failed',
      needsReview: 'Needs review',
      parsing: 'Parsing',
      partlyPublished: 'Partly published',
      published: 'Published',
      publishing: 'Publishing',
      readyToPublish: 'Ready to publish',
    },
    nameCannotBeEmpty: 'A name cannot be empty. Type a new one, or press Escape to keep it.',
    nodeAction: {
      new: 'New',
      noChange: 'No change',
      update: 'Update',
    },
    servingStatus: {
      budgetHold: 'Budget hold',
      draft: 'Draft',
      eligible: 'Eligible',
      ended: 'Ended',
      overPacing: 'Over pacing',
      paused: 'Paused',
      pending: 'Not started',
      removed: 'Removed',
      zeroBudget: 'No budget',
    },
    untitled: 'Untitled',
  },
  newProject: {
    analyzingDocuments: 'Analyzing documents...',
    cancel: 'Cancel',
    continue: 'Continue',
    createProject: 'Create project',
    details: 'Details',
    extractingKeyProjectInformation:
      'Extracting key project information from your uploaded documents.<br />This may take a moment.',
    intake: 'Intake',
    projects: 'Projects',
    skip: 'Skip',
  },
  performanceCampaignLink: {
    addCampaignDialog: {
      add: 'Add',
      addACampaign: 'Add a campaign',
      browseAnAccount: 'Browse an account',
      campaign: 'Campaign',
      chooseAnAccount: 'Choose an account…',
      connector: 'Connector',
      couldNotLinkThatCampaign: 'Could not link that campaign.',
      discovered: 'Discovered',
      discoveredCampaign: 'Discovered campaign',
      dismiss: 'Dismiss',
      loadMore: 'Load more',
      searchCampaigns: 'Search campaigns…',
    },
    platformChooser: {
      couldNotLoadOptions: 'Could not load {{label}} options',
      noCampaignsOnThisAccount: 'No campaigns on this account.',
      thePlatformDidNotAnswer: 'The platform did not answer. Nothing here is known to be missing.',
      tryAgain: 'Try again',
    },
  },
  performanceDashboard: {
    breakdownTable: {
      clicks: 'Clicks',
      conv: 'Conv.',
      cpa: 'CPA',
      cpc: 'CPC',
      cpm: 'CPM',
      ctr: 'CTR',
      impressions: 'Impressions',
      nothingDeliveredInThisPeriod: 'Nothing delivered in this period.',
      spend: 'Spend',
    },
    conversionFunnel: {
      clickThroughRate: 'Click-through rate',
      conversionRate: 'Conversion rate',
      noClicksInThisPeriod: 'No clicks in this period, so there is no conversion rate.',
      noImpressionsInThisPeriod:
        'No impressions in this period, so there is no click-through rate.',
      unknownTotal: 'Delivery totals for this period are unavailable right now.',
    },
    creativeThumbnail: {
      noPreviewAvailable: 'No preview available for this creative',
      viewFullSize: 'View {{label}} full size',
    },
    funnel: {
      clicks: 'Clicks',
      conversions: 'Conversions',
      impressions: 'Impressions',
    },
    performanceDashboard: {
      clicks: 'Clicks',
      conversions: 'Conversions',
      cpa: 'CPA',
      cpc: 'CPC',
      cpm: 'CPM',
      ctr: 'CTR',
      cvr: 'CVR',
      impressions: 'Impressions',
      noCurrencyReported:
        'Spend was reported without a currency, so there is no labelled total to show.',
      noSpendReported: 'No platform in this project reports spend, so there is no total to show.',
      spend: 'Spend',
    },
    spendShare: {
      mixedCurrencies: 'mixed currencies',
      noPlatformReportsSpend: 'No platform in this view reports spend.',
      noSpendRecordedYet: 'No spend has been recorded in this view yet.',
      rowWithCurrency: '{{label}} ({{currency}})',
      spendCantBeCompared: "Spend can't be compared as one share across currencies.",
    },
    trendCharts: {
      clicks: 'Clicks',
      conversions: 'Conversions',
      impressions: 'Impressions',
      noDeliveryInThisPeriod: 'No delivery in this period.',
      spend: 'Spend',
      spendSpansCurrencies:
        'These campaigns settle in more than one currency, so a day of spend cannot be shown as one figure. See spend by currency below.',
      spendWithCurrency: 'Spend ({{currency}})',
    },
  },
  performanceFilters: {
    performanceToolbar: {
      channels: 'Channels',
      filterByChannel: 'Filter by channel',
      filterByPlatform: 'Filter by platform',
      platforms: 'Platforms',
      searchChannels: 'Search channels',
      searchPlatforms: 'Search platforms',
    },
  },
  performancePacing: {
    pacingRow: {
      checkTheBudgetsAmountAndDates: "Check the budget's amount and dates.",
      manual: 'Manual',
      noFlightEndDateSet: 'No flight end date set',
      notPacing: 'Not pacing',
      onTrack: 'On track',
      overPacing: 'Over pacing',
      pacingForCampaign: 'Pacing for {{name}}',
      pacingUnavailable: 'Pacing unavailable',
      underPacing: 'Under pacing',
    },
    pacingTable: {
      campaign: 'Campaign',
      daysRemaining: 'Days remaining',
      deliveredVsProjected: 'Delivered vs projected',
      noCampaignsToPace: 'No campaigns to pace',
      pacing: 'Pacing',
      platform: 'Platform',
      state: 'State',
    },
    spendProgress: {
      deliveredAgainstProjected: 'Delivered against projected spend for {{name}}',
      noDeliveredSpendReported: 'No delivered spend reported to compare against the projection',
      noProjectionYet: 'No projection yet - nothing has run in this period to extrapolate from',
      ofAmount: 'of {{amount}}',
    },
  },
  performanceReports: {
    reportMenu: {
      downloadReady: 'Download ready',
      downloadReportPpt: 'Download report (PPT)',
      downloadReportXlsx: 'Download report (XLSX)',
      preparing: 'Preparing',
      reportDownloads: 'Report downloads',
      reportFailed: 'Report failed',
    },
    useReportExport: {
      failedToGenerateReport: 'Failed to generate report',
      reportGenerationFailed: 'Report generation failed. Please try again.',
      reportGenerationTimedOut: 'Report generation timed out. Please try again.',
    },
  },
  performanceScope: {
    scopeBreadcrumb: {
      allCampaigns: 'All campaigns',
      showingAllCampaigns: 'Showing all campaigns.',
    },
  },
  project: {
    constants: {
      activity: 'Activity',
      approval: 'Approval',
      brandStrategy: 'Brand Strategy',
      briefs: 'Briefs',
      campaigns: 'Campaigns',
      contentMarketing: 'Content marketing',
      createdOldestFirst: 'Created (oldest first)',
      creativeProduction: 'Creative production',
      dashboard: 'Dashboard',
      delivery: 'Delivery',
      draft: 'Draft',
      events: 'Events',
      experientialMarketing: 'Experiential marketing',
      inProgress: 'In progress',
      lastActivityOldestFirst: 'Last activity (oldest first)',
      lastActivityRecentFirst: 'Last activity (recent first)',
      library: 'Library',
      live: 'Live',
      name: 'Name',
      nameAZ: 'Name (A–Z)',
      nameZA: 'Name (Z–A)',
      overview: 'Overview',
      owner: 'Owner',
      performance: 'Performance',
      readyToReview: 'Ready to review',
      signedOff: 'Signed off',
      status: 'Status',
    },
    formSchema: {
      northAmerica: 'North America',
      worldwide: 'Worldwide',
    },
  },
  projectArtifact: {
    useExportArtifactPdf: {
      failedToExportPdf: 'Failed to export brief as PDF',
    },
  },
  projectBriefDetail: {
    suggestionOutsideFieldOptions:
      "That suggestion is not one of this field's options, so it was not applied.",
    agentsReviewing: 'Agents reviewing…',
    briefCommentsSidebar: {
      addAComment: 'Add a comment…',
      failedToIgnoreSuggestion: 'Failed to ignore suggestion',
      noCommentLeftYet: 'No comment left yet',
      noPendingComments: 'No pending comments',
      reviewTheDocumentAndType: 'Review the document and type your <br />comments below.',
      suggestionApplied: 'Suggestion applied',
      suggestionAppliedButNotResolved: 'Suggestion applied, but the comment could not be resolved',
      toggleResolvedCommentsToSee: 'Toggle resolved comments to see all <br />comments here.',
    },
    briefDetailError: {
      couldnTLoadBrief: "Couldn't load brief",
      somethingWentWrongTryAgain: 'Something went wrong. Try again.',
      tryAgain: 'Try again',
    },
    briefDetailHeader: {
      briefs: 'Briefs',
      checkForTemplateUpdates: 'Check for template updates',
      checkingForTemplateUpdates: 'Checking for template updates…',
      downloadMarkdown: 'Download Markdown',
      downloadPdf: 'Download PDF',
      duplicate: 'Duplicate',
      duplicating: 'Duplicating…',
      edit: 'Edit',
      markAsReady: 'Mark as ready',
      moreActions: 'More actions',
      preparingPdf: 'Preparing PDF…',
      ready: 'Ready',
      save: 'Save',
      saving: 'Saving…',
      hideCommentsPanel: 'Hide comments panel',
      showCommentsPanel: 'Show comments panel',
      hideInfoPanel: 'Hide info panel',
      showInfoPanel: 'Show info panel',
    },
    briefDetailLoading: {
      loadingBrief: 'Loading brief',
    },
    briefDuplicated: 'Brief duplicated',
    briefSectionFormatBar: {
      bold: 'Bold',
      bulletList: 'Bullet list',
      italic: 'Italic',
      orderedList: 'Ordered list',
      strikethrough: 'Strikethrough',
      underline: 'Underline',
    },
    briefApprovalFolders: {
      addFolder: 'Add folder',
      failedToUpdate: 'Failed to update the approval folders.',
      noFoldersAvailable: 'No folders available',
      removeFolder: 'Remove {{name}}',
    },
    briefInfoTab: {
      approvalFolders: 'Approval folders',
      briefOwner: 'Brief owner',
      createdAt: 'Created at',
      createdBy: 'Created by',
      modifiedAt: 'Modified at',
    },
    briefMarkedAsReady: 'Brief marked as ready',
    briefOwnerSelect: {
      briefOwner: 'Brief owner',
    },
    briefRightPanel: {
      comments: 'Comments',
      info: 'Info',
    },
    briefSaveIndicator: {
      failedToSave: 'Failed to save',
      failedToSaveWithError: 'Failed to save: {{error}}',
      retry: 'Retry',
      saved: 'Saved',
      savedRelative: 'Saved · {{relative}}',
      unsavedChanges: 'Unsaved changes',
    },
    briefSectionEditor: {
      youDoNotHavePermission: 'You do not have permission to edit.',
    },
    briefSectionShell: {
      commentsOnThisSection_one: '{{count}} comment on this section',
      commentsOnThisSection_other: '{{count}} comments on this section',
      required: 'Required',
      requiredFieldEmpty: 'This field is required',
      acceptSuggestion: 'Accept',
      clearSuggestion: 'Clear',
      suggestedByAi: 'Suggested by AI',
      suggestedByAiExplainer:
        'An agent filled this in. It is not part of the brief until you accept or edit it.',
      commentOnSection: 'Comment on section',
      helperTextTooltip: 'Field guidance',
      retired: 'Retired',
      text: { helperText: 'Free-form text. Written as flowing prose, not a list of fields.' },
      date: {
        helperText: 'A single date, or a date range, depending on how this field is set up.',
      },
      select: { helperText: 'Choose one option from the list.' },
      checklist: { helperText: 'Choose any number of options from the list.' },
      url: { helperText: 'A web address. Starts with https:// unless configured otherwise.' },
      file: { helperText: 'Attach a file. Accepted types and size limits depend on this field.' },
      boolean: { helperText: 'A yes or no answer.' },
    },
    briefSectionError: {
      cannotDisplaySection: 'Cannot display section: {{name}}',
      theSectionContentIsIn:
        'The section content is in an unexpected format and cannot be rendered.',
    },
    briefSectionAgentProse: {
      writtenByAnAgentBefore: 'Written by an agent before this field became a typed field',
      copyWhatYouNeedInto:
        'Copy what you need into the field above. This note goes away once the field has an answer.',
    },
    briefSectionField: {
      dateField: {
        startDate: 'Start date',
        endDate: 'End date',
        rangeFromToday: 'From today',
        rangeFrom: 'From {{min}}',
        rangeUntil: 'Until {{max}}',
        rangeBetween: 'Between {{min}} and {{max}}',
        rangeBetweenToday: 'Between today and {{max}}',
      },
      selectField: {
        placeholder: 'Select an option',
      },
      urlField: {
        placeholder: 'https://',
        openLink: 'Open link',
      },
      fileField: {
        addFile: 'Add file',
        remove: 'Remove {{name}}',
        limits: '{{types}} · up to {{size}} MB',
        sizeLimit: 'Up to {{size}} MB',
        rejectedType: '"{{name}}" isn\'t allowed here. Allowed: {{types}}.',
        rejectedSize: '"{{name}}" is {{size}} MB. Files here can be up to {{limit}} MB.',
        rejectedCount: 'Only {{max}} file(s) allowed for this field.',
        uploading: 'Uploading files…',
        uploadFailed: 'Files could not be uploaded. Nothing was attached.',
      },
      booleanField: {
        unanswered: 'Not answered',
      },
    },
    deriveSubmitDisabledReason: {
      alreadyMarkedAsReady: 'Already marked as ready',
      fixValidationErrorsFirst: 'Fix validation errors first',
      saveChangesBeforeMarkingAs: 'Save changes before marking as ready',
      savingInProgress: 'Saving in progress…',
    },
    failedToDuplicateBrief: 'Failed to duplicate brief',
    failedToMarkAsReady: 'Failed to mark as ready',
    failedToSaveBrief: 'Failed to save brief',
    markBriefReadyDialog: {
      alreadyDelivered:
        'This brief is already delivered into {{folders}}. No second folder will be created.',
      close: 'Close',
      createFolder: 'Create folder',
      createFolderAndMarkAsReady: 'Create folder and mark as ready',
      failedToCreateFolder: 'Failed to create the approval folder',
      folderCreated: 'Approval folder "{{name}}" created',
      folderName: 'Folder name',
      folderNameIsRequired: 'Folder name is required',
      markAsReady: 'Mark as ready',
      markAsReadyWithoutFolder: 'Mark as ready without creating a folder',
      nameIsTooLong: 'Name must be at most {{max}} characters',
      title: 'Mark brief as ready',
      willCreateFolder: 'An approval folder will be created to receive the work for this brief.',
    },
    openCopy: 'Open copy',
    panelResizeHandle: {
      resizeCommentsPanel: 'Resize comments panel',
    },
    reconcileTemplate: {
      addedAndRetiredFields: 'Updated from the template: {{added}} added, {{retired}} retired.',
      addedFields_one: 'The template added {{count}} field to this brief.',
      addedFields_other: 'The template added {{count}} fields to this brief.',
      clearedAnswers_one:
        'The template changed {{count}} field, and the answer it held was cleared: {{fields}}.',
      clearedAnswers_other:
        'The template changed {{count}} fields, and the answers they held were cleared: {{fields}}.',
      failed: 'The template check could not be completed.',
      noTemplate: 'This brief was not created from a template, so there is nothing to check.',
      retiredFields_one:
        'The template no longer uses {{count}} field. Its answer is kept and marked retired.',
      retiredFields_other:
        'The template no longer uses {{count}} fields. Their answers are kept and marked retired.',
      templateUnavailable:
        'The template could not be reached, so nothing was changed. Try again shortly.',
      upToDate: 'This brief already matches its template.',
    },
  },
  projectComment: {
    attachmentChipList: {
      removeAttachment: 'Remove {{filename}}',
      showMoreAttachments_one: 'Show {{count}} more attachment',
      showMoreAttachments_other: 'Show {{count}} more attachments',
    },
    briefComment: {
      commentIsAnchoredToSection: 'Comment is anchored to the {{section}} section',
      highlight: 'Highlight',
      textRemoved: 'Text removed',
      textTheHighlightReferencedHas: 'Text the highlight referenced has been removed',
    },
    comment: {
      approve: 'Approve',
      cancel: 'Cancel',
      cancelReply: 'Cancel reply',
      commentActions: 'Comment actions',
      copyLink: 'Copy Link',
      delete: 'Delete',
      edit: 'Edit',
      editYourComment: 'Edit your comment...',
      leaveYourReply: 'Leave your reply',
      reply: 'Reply',
      replyCount_one: '{{count}} reply',
      replyCount_other: '{{count}} replies',
      save: 'Save',
    },
    fileComment: {
      annotatedAt: 'Annotated at {{timestamp}}',
      annotationCount_one: '{{count}} annotation',
      annotationCount_other: '{{count}} annotations',
    },
    commentCardSurface: {
      thisCommentWasDeleted: 'This comment was deleted',
    },
    commentInput: {
      submitComment: 'Submit comment',
    },
    pendingAttachmentChips: {
      removeAttachment: 'Remove {{filename}}',
    },
    useCommentAttachments: {
      attachmentsMustBeUnder: '"{{filename}}" is {{size}}. Attachments must be under {{max}}.',
      failedToUpload: 'Failed to upload "{{filename}}". Please try again.',
      youCanAttachAtMost_one:
        'You can attach at most {{max}} files per comment. {{count}} file skipped.',
      youCanAttachAtMost_other:
        'You can attach at most {{max}} files per comment. {{count}} files skipped.',
    },
  },
  projectDetail: {
    projectDetailTabs: {
      projectSections: 'Project sections',
    },
    projectHeaderBar: {
      cancel: 'Cancel',
      couldNotDeleteProject: 'Could not delete project',
      couldNotRenameProject: 'Could not rename project',
      delete: 'Delete',
      deleteConfirmation:
        'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
      deleteProject: 'Delete project',
      duplicateNotAvailableYet: 'Duplicating a project is not available yet',
      duplicateProject: 'Duplicate project',
      projectName: 'Project name',
      projects: 'Projects',
      share: 'Share',
    },
    jobReview: {
      accountJoin: '; ',
      accountUnreachable: '{{name}} is {{status}}. Reconnect it in Knowledge Hub.',
      checkedThePlanBut: 'Checked the plan, but {{accounts}}',
      couldNotBindThatAdAccount: 'Could not bind that ad account.',
      couldNotRemoveThisPlatform: 'Could not remove this platform. Try again.',
      couldNotSignIn:
        '{{name}} could not be signed in to: {{detail}}. Reconnect it in Knowledge Hub.',
      couldNotCheckWithThePlatform: 'Could not check this plan with the platform.',
      couldNotClearTheFindings: 'Could not clear the findings.',
      couldNotPublishThisJob: 'Could not publish this Job.',
      couldNotReadWhatThePublishDid: 'Could not read what the publish did.',
      couldNotRunThePreflightCheck: 'Could not run the pre-flight check.',
      couldNotSaveThatChange: 'Could not save that change.',
      couldNotSelectThatClient: 'Could not choose that client account.',
      couldNotSelectThatPage: 'Could not select that page.',
      delivery: 'Delivery',
      findingsCleared: 'Findings cleared. Run pre-flight when you are ready.',
      itMayHaveBeenRemoved: 'It may have been removed from this project.',
      jobNotFound: 'Job not found',
      planCouldNotBeRead: 'The plan could not be read',
      readingThePlan: 'Reading the plan',
      readingThePlanDetail:
        'Unpacking the zip and storing its creatives. You can leave this page; the plan will be here when it is done.',
      readingProgress:
        '{{step}}. Tab {{tabsDone}} of {{tabsTotal}}, {{rowsDone}} of {{rowsTotal}} rows. You can leave this page; the plan will be here when it is done.',
      readingThePlanDetailAgent:
        'The agent is reading the plan into the job. You can leave this page; the plan will be here when it is done.',
      tabsToChoose: 'Which tabs hold the plan?',
      tabsToChooseDetail:
        'This workbook has several tabs, and nothing has been read yet. Pick the tabs to read, or drop the upload.',
      chooseTabs: 'Choose tabs',
      dropUpload: 'Drop the upload',
      uploadAPlan: 'Upload a plan',
      uploadingAPlan: 'Uploading…',
      noPlanYet: 'No plan yet',
      noPlanYetDetail:
        'Nothing has been read into this job. Upload the Monks.Flow template, or a client plan.',
      listJoin: ' and ',
      namesNotCheckedOn:
        'Could not read what is already on {{platforms}}, so no name here was checked against it. Publishing may create a second copy of something that exists there. Run pre-flight again to check.',
      noAdvertiser:
        '{{name}} reaches several client accounts and this job has not chosen one. Choose one next to Publishing into.',
      notReachable: 'not reachable',
      platformCheckDidNotReportBack:
        'The platform check did not report back in time. Run it again to retry.',
      preflightFound: 'Pre-flight found {{parts}}.',
      preflightFoundNothing: 'Pre-flight found nothing to fix.',
      toCheck: '{{count}} to check',
      toFix: '{{count}} to fix',
    },
    jobPlatformTabs: {
      noAccount: 'No account',
      platformsInThisJob: 'Platforms in this job',
      removeFromThisJob: 'Remove {{platform}} from this job',
      rowsInThisPlan: '{{count}} {{noun}} in this plan',
    },
    delivery: {
      andMoreFiles: 'and {{count}} more',
      couldNotDeleteThatJob: 'Could not delete that job.',
      couldNotDownloadThatFile:
        'Could not download that file. It may not have been kept for this job.',
      couldNotDownloadTheTemplate: 'Could not download the template. Try again.',
      couldNotLoadThePlatformList:
        'Could not load the platform list, so a job cannot be started. Reload and try again.',
      couldNotReadThatPlan: 'Could not read that plan.',
      planIsReadyToReview: '{{title}} is ready to review.',
      noTabsWereRead: 'No tabs were read yet. Pick them from the job when you are ready.',
      couldNotUploadTheCreatives_one:
        'Could not upload {{count}} creative: {{fileNames}}. The plan is saved, so add it from the job when you are ready.',
      couldNotUploadTheCreatives_other:
        'Could not upload {{count}} creatives: {{fileNames}}. The plan is saved, so add them from the job when you are ready.',
      deleteDetail:
        'The plan and everything reviewed on it goes. Nothing was published, so nothing on the ad account changes.',
      deleteJob: 'Delete job',
      deleteJobTitle: 'Delete “{{title}}”?',
      deletePublishedDetail:
        'This job is {{status}}. Anything it published stays live on the ad account — deleting the job loses track of it rather than taking it down.',
      deleting: 'Deleting…',
      delivery: 'Delivery',
      introDescription:
        'Upload a media plan, review what it would create on each platform, and publish it.',
      keepIt: 'Keep it',
      someCreativesDidNotUpload_one:
        '{{count}} creative did not upload: {{fileNames}}. Drop it on the row that needs it.',
      someCreativesDidNotUpload_other:
        '{{count}} creatives did not upload: {{fileNames}}. Drop them on the rows that need them.',
      someCreativesWereRefused_one: '{{count}} creative did not upload: {{details}}.',
      someCreativesWereRefused_other: '{{count}} creatives did not upload: {{details}}.',
      stillLoadingThePlatformList: 'Still loading the platform list. Try again in a moment.',
    },
    addArtifactsModal: {
      add: 'Add',
      addArtifactsFromWorkspace: 'Add Artifacts from Workspace',
      addExistingArtifacts: 'Add existing artifacts',
      addWithCount: 'Add ({{addCount}})',
      back: 'Back',
      cancel: 'Cancel',
      fromYourComputer: 'From your computer',
      importArtifacts: 'Import artifacts',
      retryWithCount: 'Retry ({{addCount}})',
      selectArtifacts: 'Select artifacts',
      selectAWorkspaceToContinue: 'Select a workspace to continue.',
      uploadDocuments: 'Upload documents',
      uploadDocuments2: 'Upload Documents',
      uploading: 'Uploading...',
    },
    artifactCard: {
      addedToLibrary: 'Added to library',
      artifactActions: 'Artifact actions',
      delete: 'Delete',
      view: 'View',
    },
    artifactPreviewError: {
      artifactNoLongerAttached: 'Artifact no longer attached',
      close: 'Close',
      couldnTLoadArtifact: "Couldn't load artifact",
      somethingWentWrongLoadingThis: 'Something went wrong loading this artifact. Try again.',
      thisArtifactWasRemovedFrom:
        'This artifact was removed from the project. Close to refresh the list.',
      tryAgain: 'Try again',
    },
    artifactPreviewFallback: {
      previewNotAvailable: 'Preview not available',
    },
    artifactPreviewModal: {
      openChatSessionInNew: 'Open chat session in new tab',
      versionBadge: 'v{{version}}',
    },
    artifactPreviewNavigation: {
      nextArtifact: 'Next artifact',
      previousArtifact: 'Previous artifact',
    },
    artifactsEmptyState: {
      addArtifacts: 'Add artifacts',
      clearFilters: 'Clear filters',
      noMatchingArtifacts: 'No matching artifacts',
      tryADifferentSearchOr: 'Try a different search or filter.',
    },
    artifactsToolbar: {
      addArtifacts: 'Add artifacts',
      allTypes: 'All types',
      filterByType: 'Filter by type',
      newestFirst: 'Newest first',
      searchArtifacts: 'Search artifacts',
      type: 'Type',
    },
    assetApprovalPrimary: {
      hideApprovalPanelWithProgress: 'Hide approval panel, {{progress}}',
      showApprovalPanelWithProgress: 'Show approval panel, {{progress}}',
    },
    assetComparePane: {
      leftVersion: 'Left version',
      rightVersion: 'Right version',
      version: 'Version {{versionLabel}}',
      versionSelector: '{{side}} selector',
    },
    assetCompareView: {
      compareVersions: 'Compare Versions',
      couldNotLoadFolder: "Couldn't load this asset's folder.",
      folders: 'Folders',
      oneOfTheSelectedVersions:
        'One of the selected versions could not be loaded. They may have been deleted.',
      openAFileAndUse:
        'Open a file and use the version selector to launch compare against another version.',
      pickTwoDifferentVersionsTo: 'Pick two different versions to compare',
      versionsNotFound: 'Versions not found',
    },
    assetDetail: {
      assetNotFound: 'Asset not found',
      couldNotLoadFolder: "Couldn't load this asset's folder.",
      thisFileCouldNotBe:
        "This file could not be loaded. It may have been deleted or you don't have access.",
      updating: 'Updating…',
    },
    assetDetailFullScreen: {
      assetPreview: 'Asset preview',
    },
    assetDetailHeader: {
      aNewerVersionExists: 'A newer version exists',
      copyCurrentUrl: 'Copy current URL',
      failedToCopyLink: 'Failed to copy link',
      failedToUploadNewVersion: 'Failed to upload new version',
      linkCopied: 'Link copied',
      newVersionUploaded: 'New version uploaded',
      reload: 'Reload',
      reloadToViewTheLatest: 'Reload to view the latest version before uploading again.',
      tryAgainAndIfThe: 'Try again and if the error persists contact support',
    },
    assetFilmstrip: {
      approved: 'Approved',
      filterByStatus: 'Filter by status',
      noFilesMatchThisFilter: 'No files match this filter.',
      status: 'Status',
    },
    assetGrid: {
      couldNotDeleteFile: 'Could not delete file.',
      failedToCopyLink: 'Failed to copy link',
      fileDeleted: 'File deleted.',
      linkCopied: 'Link copied',
      thisFileWillBeMoved: 'This file will be moved to the archive. This action cannot be undone.',
    },
    assetPreview: {
      download: 'Download',
      previewNotAvailableForThis: 'Preview not available for this file type.',
    },
    assetSidebar: {
      addAComment: 'Add a comment…',
      approval: 'Approval chain',
      editChain: 'Edit chain',
      noApprovalChainAssigned: 'No approval chain assigned',
      onlyChainManagersCanAssign:
        'Only people who can manage approval chains can assign one to this asset.',
      comments: 'Comments',
      commentsWillAppearHereOnce: 'Comments will appear here once added.',
      details: 'Details',
      fileName: 'File name',
      noCommentLeftYet: 'No comment left yet',
      noPendingComments: 'No pending comments',
      resizePanel: 'Resize details panel',
      size: 'Size',
      status: 'Status',
      toggleResolvedCommentsToSee: 'Toggle resolved comments to see all <br />comments here.',
      type: 'Type',
      uploaded: 'Uploaded',
      hideDetailsPanel: 'Hide details panel',
      showDetailsPanel: 'Show details panel',
      hideCommentsPanel: 'Hide comments panel',
      showCommentsPanel: 'Show comments panel',
      hideApprovalPanel: 'Hide approval panel',
      showApprovalPanel: 'Show approval panel',
    },
    assetsSection: {
      allAssetsSelected_one: '{{count}} asset is selected',
      allAssetsSelected_other: 'All {{count}} assets are selected',
      noMatchingAssets: 'No matching assets',
      tryADifferentSearchOr: 'Try a different search or filter.',
      clearFilters: 'Clear filters',
      all: 'All',
      allStatuses: 'All statuses',
      approved: 'Approved',
      approve: 'Approve',
      assignApprovalChain: 'Assign approval chain',
      bulkActions: 'Bulk actions',
      cancel: 'Cancel',
      failedToApproveAssets: 'Failed to approve assets.',
      inReview: 'In review',
      newestFirst: 'Newest first',
      oldestFirst: 'Oldest first',
      readyForReview: 'Ready for review',
      removeApprovalChain: 'Remove approval chain',
      searchAssets: 'Search assets',
      select: 'Select',
      selectAll: 'Select all',
      selectedCount: '{{selectedCount}} selected',
      sortAssets: 'Sort assets',
      sort: 'Sort',
      status: 'Status',
      markInReview: 'Mark in review',
      uploadAssets: 'Upload assets',
      uploadFailedClickToDismiss: 'Upload failed. Click to dismiss.',
    },
    back: 'Back',
    briefArtifactPreview: {
      download: 'Download',
      downloadBrief: 'Download brief',
      downloadMarkdown: 'Download Markdown',
      downloadPdf: 'Download PDF',
      preparingPdf: 'Preparing PDF…',
    },
    briefing: {
      briefGenerated: 'Brief generated',
      briefs: 'Briefs',
      dismiss: 'Dismiss',
    },
    briefsActionMenu: {
      briefActions: 'Brief actions',
      delete: 'Delete',
      downloadMarkdown: 'Download Markdown',
      downloadPdf: 'Download PDF',
      duplicate: 'Duplicate',
      edit: 'Edit',
      preparingPdf: 'Preparing PDF…',
      thisActionCannotBeUndone: 'This action cannot be undone.',
    },
    briefsConstants: {
      createBriefsAgenticallyFromYour:
        'Create briefs agentically from your inputs and existing documents, then refine them with agents.',
      draft: 'Draft',
      lastModifiedOldestFirst: 'Last modified (oldest first)',
      nameAZ: 'Name (A–Z)',
      nameZA: 'Name (Z–A)',
      ready: 'Ready',
      statusAZ: 'Status (A–Z)',
      typeAZ: 'Type (A–Z)',
    },
    briefsEmptyState: {
      briefs: 'Briefs',
      clearFilters: 'Clear filters',
      newBrief: 'New brief',
      noMatchingBriefs: 'No matching briefs',
      tryADifferentSearchOr: 'Try a different search or filter.',
    },
    briefsErrorState: {
      couldnTLoadBriefs: "Couldn't load briefs",
      somethingWentWrongTryAgain: 'Something went wrong. Try again.',
      tryAgain: 'Try again',
    },
    briefsPagination: {
      briefsPagination: 'Briefs pagination',
      nextPage: 'Next page',
      pageOf: 'Page {{currentPage}} of {{totalPages}}',
      previousPage: 'Previous page',
    },
    approvalFolderRail: {
      approvalFolders: 'Approval folders',
      collapseFolder: 'Collapse {{name}}',
      couldNotLoadFolders: "Couldn't load folders",
      expandFolder: 'Expand {{name}}',
      foldersAreStillThere:
        'Something went wrong fetching this project’s folders. Nothing has been lost, so try again in a moment.',
      foldersNotShown_one: '{{count}} more folder is not shown here.',
      foldersNotShown_other: '{{count}} more folders are not shown here.',
      newFolder: 'New folder',
      noFoldersYet: 'No folders yet',
      tryAgain: 'Try again',
    },
    briefsTable: {
      actions: 'Actions',
      lastModified: 'Last modified',
      name: 'Name',
      status: 'Status',
      title: 'Title',
      type: 'Type',
    },
    briefsToolbar: {
      allStatuses: 'All statuses',
      lastModifiedNewestFirst: 'Last modified (newest first)',
      newBrief: 'New brief',
      searchBriefsByTitle: 'Search briefs by title…',
      status: 'Status',
    },
    emptyFolderPage: {
      addFoldersInsideItOrUpload:
        'Add folders inside it or upload assets for approval. A folder holds one or the other.',
      clickToUploadOrDrag: 'Click to upload or drag and drop',
      imagesVideosAudioAndPdf: 'PNG, JPG, MP4 or PDF · up to 100 MB each',
      thisFolderIsEmpty: 'This folder is empty',
      uploadFailedClickToDismiss: 'Upload failed. Click to dismiss.',
    },
    expandableFolderRow: {
      collapseFolder: 'Collapse folder',
      couldNotLoadSubfolders: 'Could not load subfolders. Please try again.',
      expandFolder: 'Expand folder',
    },
    fileAssetCard: {
      approveStep: 'Approve {{step}}',
      commentCount_one: '{{count}} comment',
      commentCount_other: '{{count}} comments',
      copyLink: 'Copy link',
      delete: 'Delete',
      download: 'Download',
      editTags: 'Edit tags',
      failedToApproveStep: 'Failed to approve step.',
      failedToDownloadFile: 'Failed to download file.',
      fileActions: 'File actions',
      loadingApprovalSteps: 'Loading…',
      rename: 'Rename',
      selectFile: 'Select {{fileName}}',
      status: 'Status',
      stepApproved: '{{step}} · approved',
      stepApprovedToast: '{{step}} approved.',
      versionBadge: 'v{{versionNumber}}',
    },
    briefsTableRow: {
      deliveredInto_one: 'Delivered into {{names}}',
      deliveredInto_other: 'Delivered into {{count}} folders: {{names}}',
    },
    folderApprovalChainTags: {
      approvalChainSummary: 'Approval progress by chain',
      countsCoverLoadedAssets:
        'Chain counts cover the {{loaded}} of {{total}} assets currently loaded.',
      newUploadsGet: 'New uploads to this folder will use {{name}}',
      progress: '{{approved}}/{{total}} approved',
      tagProgress: '{{name}} — {{approved}}/{{total}} approved',
    },
    folderActionsMenu: {
      changeThumbnail: 'Change thumbnail',
      couldNotDeleteFolder: 'Could not delete folder.',
      deleteFolder: 'Delete folder',
      download: 'Download',
      folderActions: 'Folder actions',
      renameFolder: 'Rename folder',
      setApprovalChain: 'Set approval chain',
      folderDeleted: 'Folder deleted.',
      thisActionCannotBeUndone:
        'This action cannot be undone. The folder will be permanently removed.',
      thisActionCannotBeUndoneWithSubfolders:
        'This action cannot be undone. The folder and everything nested inside it will be permanently removed.',
    },
    folderApprovalChainDialog: {
      alsoApplyToSubfolders: 'Also apply to subfolders',
      approvalChain: 'Approval chain',
      clear: 'Clear',
      cancel: 'Cancel',
      newUploadsGetThisChain:
        'Applies to new assets uploaded to "{{folderName}}". Assets already in the folder don\'t change.',
      noApprovalChain: 'No approval chain',
      save: 'Save',
      setApprovalChain: 'Set approval chain',
    },
    folderPaneHeader: {
      folderRenamed: 'Folder renamed to {{folderName}}',
    },
    folderDetailPage: {
      folderNotFound: 'Folder not found',
      thisFolderCouldNotBe:
        "This folder could not be loaded. It may have been deleted or you don't have access.",
    },
    folderPane: {
      newFolder: 'New folder',
      uploadAssets: 'Upload assets',
    },
    railToggleButton: {
      hideFolders: 'Hide folders',
      showFolders: 'Show folders',
    },
    subfolderGrid: {
      created: 'Created {{date}}',
      createdByOn: 'Created by {{name}} · {{date}}',
      foldersNotShown_one: '{{count}} more folder is not shown here.',
      foldersNotShown_other: '{{count}} more folders are not shown here.',
    },
    foldersConstants: {
      approved: 'Approved',
      inReview: 'In review',
      na: 'N/A',
      rejected: 'Rejected',
    },
    foldersListPage: {
      folders: 'Folders',
      noFoldersYet: 'No folders yet',
      noFoldersYetDescription: 'Create a folder to start organizing and reviewing your assets.',
    },
    fullscreenToggle: {
      exitFullscreen: 'Exit fullscreen',
      expand: 'Expand',
    },
    fullscreenTopBar: {
      closeFullscreen: 'Close fullscreen',
      download: 'Download',
      failedToDownloadFile: 'Failed to download file',
      nextAsset: 'Next asset',
      previousAsset: 'Previous asset',
    },
    library: {
      deleteFile: 'Delete file?',
      removeFromProject: 'Remove from project?',
      theArtifactStaysInYour:
        'The artifact stays in your workspace and is only removed from this project.',
      thisPermanentlyDeletesTheFile: 'This permanently deletes the file from the project.',
    },
    libraryConstants: {
      library: 'Library',
      nameAZ: 'Name (A–Z)',
      nameZA: 'Name (Z–A)',
      oldestFirst: 'Oldest first',
      referencesKnowledgeAndOtherInput: 'References, knowledge and other input for your project',
    },
    manageCampaigns: {
      actions: 'Actions',
      addCampaign: 'Add campaign',
      adServing: 'Ad serving',
      buying: 'Buying',
      campaign: 'Campaign',
      channel: 'Channel',
      couldNotChangeThatRole: 'Could not change that role.',
      couldNotLoadThisProjectsCampaigns: "Could not load this project's campaigns",
      couldNotRemoveThatCampaign: 'Could not remove that campaign.',
      currency: 'Currency',
      everyCampaignHereContributes: 'Every campaign here contributes to the Overview.',
      flight: 'Flight',
      itStopsContributingToTheOverview:
        'It stops contributing to the Overview. The campaign itself stays live on the ad account - this changes what we report, not what is running.',
      keepIt: 'Keep it',
      linkACampaignFromAConnectedAccount:
        'Link a campaign from a connected ad account and its delivery appears on the Overview.',
      manual: 'Manual',
      noCampaignsYet: 'No campaigns yet',
      platform: 'Platform',
      remove: 'Remove',
      removeCampaign: 'Remove {{name}}',
      removeFromProject: 'Remove from project',
      removeFromThisProject: 'Remove “{{name}}” from this project?',
      removing: 'Removing…',
      role: 'Role',
      roleForCampaign: 'Role for {{name}}',
      serving: 'Serving',
      theRequestDidNotComeBack: 'The request did not come back.',
      tryAgain: 'Try again',
      uploadDelivery: 'Upload delivery',
      upload: {
        datesCovered:
          'Dates covered: {{start}} to {{end}}. Check that the days and months read as you meant.',
        cancel: 'Cancel',
        title: 'Upload delivery',
        description:
          "Add daily delivery for this project's manual campaigns from a CSV or Excel report.",
        dropTitle: 'Drop a CSV or Excel file here',
        dropCaption: 'One file, up to 10 MB',
        invalidFile: 'Choose one CSV or Excel file up to 10 MB.',
        reading: 'Reading the file…',
        problemsTitle_one: '{{count}} problem to fix in the file',
        problemsTitle_other: '{{count}} problems to fix in the file',
        problemsHint: 'Fix them in the file, then upload it again. Nothing was written.',
        wholeFile: 'Whole file',
        rowNumber: 'Row {{row}}',
        notInProjectTitle_one: '{{count}} campaign not in this project',
        notInProjectTitle_other: '{{count}} campaigns not in this project',
        notInProjectHint:
          'If one is a typo, fix it in the file. You can create the others once the file has no problems.',
        newCampaignsTitle_one: 'Create {{count}} new campaign',
        newCampaignsTitle_other: 'Create {{count}} new campaigns',
        newCampaignsHint:
          "These names aren't in this project yet. Import creates them with their delivery.",
        rows_one: '{{count}} row',
        rows_other: '{{count}} rows',
        chooseAnotherFile: 'Choose another file',
        import: 'Import',
        importing: 'Importing…',
        done: 'Done',
        resultTitle: 'Delivery imported',
        rowsWritten_one: '{{count}} campaign day written.',
        rowsWritten_other: '{{count}} campaign days written.',
        createdCampaigns_one: '{{count}} campaign created: {{names}}',
        createdCampaigns_other: '{{count}} campaigns created: {{names}}',
        ignoredColumns: 'Columns not read: {{columns}}',
        platformNoticesTitle: 'Some platforms were not set',
        platformUnknown: '{{campaign}}: "{{labels}}" is not a platform we recognise.',
        platformMixed: '{{campaign}}: its rows name more than one platform ({{labels}}).',
        platformKept: '{{campaign}}: kept {{platform}}; the file names {{labels}}.',
        clearedTitle: 'Some figures were cleared',
        cleared:
          'The file has no column for {{metrics}}, so those figures were cleared on the days it covers.',
        failed: "The upload didn't go through. Try again.",
        nameTaken:
          'Another upload created one of these campaigns meanwhile. Send the file again and its rows go to that campaign.',
        inProgress: 'This file is still being written. Wait a moment and try again.',
        sendAgain: 'Send again',
      },
    },
    minimapPreview: {
      dragToPanViewport: 'Drag to pan viewport',
    },
    overview: {
      yourProject: 'your project',
    },
    pdfPageNavigator: {
      currentPage: 'Current page',
      page: 'Page',
    },
    pdfViewer: {
      passwordProtectedPdfsArenT: 'Password-protected PDFs aren’t supported yet.',
      pdfUnavailable: 'PDF unavailable',
      thisPdfCouldnTBe: 'This PDF couldn’t be loaded.',
    },
    performance: {
      audienceAndPlacement: 'Audience & Placement',
      creative: 'Creative',
      introDescription:
        'How the campaigns on this project are delivering, and which ones count towards it.',
      manageCampaigns: 'Manage campaigns',
      overview: 'Overview',
      pacing: 'Pacing',
      performance: 'Performance',
      performanceViews: 'Performance views',
      singleCampaign: 'Single campaign',
    },
    performanceAudience: {
      addACampaign: 'Add a campaign',
      audienceReportingIsNotAvailable:
        'Audience and placement reporting is not available for these platforms',
      couldNotLoadAudiencePerformance: 'Could not load audience and placement performance',
      missingFromThisBreakdown:
        "{{campaignCount}} campaign(s) don't report delivery by audience segment or placement, so they are missing from this breakdown: {{names}}.",
      noCampaignMatchesTheseFilters:
        'No campaign matches the current date range, platform and channel filters. Widen them to see delivery.',
      noCampaignsYet: 'No campaigns yet',
      noneOfTheConnectedAccounts:
        'None of the connected accounts reports delivery by audience segment or placement, so there is nothing to break out here. Spend and delivery totals are unaffected.',
      nothingDeliveredInThisView: 'Nothing delivered in this view',
      theCampaignThisLinkPointsTo:
        "The campaign this link points to isn't part of this project, or has been removed.",
      theRequestDidNotComeBack: 'The request did not come back.',
      thisBreakdownCoversTheCampaigns:
        'This breakdown covers the campaigns added to this project. Add one to see how it is delivering by audience segment or placement.',
      thisCampaignIsntInThisProject: "This campaign isn't in this project",
      tryAgain: 'Try again',
    },
    performanceCreative: {
      addACampaign: 'Add a campaign',
      couldNotLoadCreativePerformance: 'Could not load creative performance',
      creativeReportingIsNotAvailable: 'Creative reporting is not available for these platforms',
      missingFromThisLeaderboard:
        "{{campaignCount}} campaign(s) don't report delivery per creative, so they are missing from this leaderboard: {{names}}.",
      noCampaignMatchesTheseFilters:
        'No campaign matches the current date range, platform and channel filters. Widen them to see delivery.',
      noCampaignsYet: 'No campaigns yet',
      noneOfTheConnectedAccounts:
        'None of the connected accounts reports delivery per creative, so there is nothing to rank here. Spend and delivery totals are unaffected.',
      nothingDeliveredInThisView: 'Nothing delivered in this view',
      theCampaignThisLinkPointsTo:
        "The campaign this link points to isn't part of this project, or has been removed.",
      theRequestDidNotComeBack: 'The request did not come back.',
      thisCampaignIsntInThisProject: "This campaign isn't in this project",
      thisLeaderboardRanksTheCampaigns:
        'This leaderboard ranks the campaigns added to this project. Add one to see how its creatives are performing.',
      tryAgain: 'Try again',
    },
    performanceOverview: {
      addACampaign: 'Add a campaign',
      couldNotLoadThisProjectsPerformance: "Could not load this project's performance",
      noCampaignMatchesTheseFilters:
        'No campaign matches the current date range, platform and channel filters. Widen them to see delivery.',
      noCampaignsYet: 'No campaigns yet',
      nothingDeliveredInThisView: 'Nothing delivered in this view',
      theCampaignThisLinkPointsTo:
        "The campaign this link points to isn't part of this project, or has been removed.",
      theRequestDidNotComeBack: 'The request did not come back.',
      thisCampaignIsntInThisProject: "This campaign isn't in this project",
      thisDashboardReportsTheCampaigns:
        'This dashboard reports the campaigns added to this project. Add one to see how it is delivering.',
      tryAgain: 'Try again',
    },
    performancePacing: {
      couldNotLoadThisProjectsPacing: "Could not load this project's pacing",
      manageCampaigns: 'Manage campaigns',
      noCampaignsYet: 'No campaigns yet',
      theCampaignThisLinkPointsTo:
        "The campaign this link points to isn't part of this project, or has been removed.",
      theRequestDidNotComeBack: 'The request did not come back.',
      thisCampaignIsntInThisProject: "This campaign isn't in this project",
      thisViewPacesTheCampaigns:
        'This view paces the campaigns added to this project. Add one to see whether it is on track to spend its budget.',
      tryAgain: 'Try again',
    },
    projectDetail: {
      project: 'project',
    },
    projectNotFound: 'Project not found',
    savedFileArtifactPreview: {
      savedFileArtifactHasNo: 'Saved file artifact has no asset id',
    },
    syncPlayToggleButton: {
      disableSyncPlayback: 'Disable sync playback',
      enableSyncPlayback: 'Enable sync playback',
      sync: 'Sync',
      synced: 'Synced',
      syncPlaybackAcrossBothVideos: 'Sync playback across both videos',
    },
    textViewer: {
      couldnTPreviewThisFile: "Couldn't preview this file",
      downloadFile: 'Download file',
      previewTruncatedAt:
        'Preview truncated at {{sizeKb}} KB. Download the file for full contents.',
      somethingWentWrongLoadingThe:
        'Something went wrong loading the preview. Try downloading it instead.',
      theFileMayHaveBeen: 'The file may have been removed or expired.',
      thisFileIsNoLonger: 'This file is no longer available',
    },
    thumbnailPicker: {
      assets: 'Assets',
      cancel: 'Cancel',
      changeFolderThumbnail: 'Change folder thumbnail',
      clearOverride: 'Clear override',
      loadingAssets: 'Loading assets…',
      pickAnyAssetInThis:
        'Pick any asset in this folder to pin it as the thumbnail. Clear the override to auto-select the oldest uploaded asset.',
      thisFolderHasNo: 'This folder has no assets yet. Upload something to pick a thumbnail.',
      selectAsThumbnail: 'Select {{fileName}} as thumbnail',
      save: 'Save',
      saving: 'Saving…',
    },
    uploadView: {
      addedFilesWillAppearHere: 'Added files will appear here',
      dismissWarning: 'Dismiss warning',
      dropDocumentsHere: 'Drop documents here',
      filesQueued_one: '{{count}} file queued',
      filesQueued_other: '{{count}} files queued',
      pdfDocDocxTxtRtf: 'PDF, DOC, DOCX, TXT, RTF · Max 10MB',
      upload: 'Upload',
    },
    useLibraryDelete: {
      artifactRemovedFromProject: 'Artifact removed from project.',
      couldNotDeleteFile: 'Could not delete file.',
      couldNotRemoveArtifactFrom: 'Could not remove artifact from project.',
      fileDeleted: 'File deleted.',
    },
    useUploadQueue: {
      filesAlreadyAdded_one: '{{count}} file already added',
      filesAlreadyAdded_other: '{{count}} files already added',
      filesExceededThe10MbSize_one: '{{count}} file exceeded the 10MB size limit',
      filesExceededThe10MbSize_other: '{{count}} files exceeded the 10MB size limit',
      unsupportedFilesSkipped_one:
        '{{count}} unsupported file skipped — supported: PDF, DOC, DOCX, TXT, RTF.',
      unsupportedFilesSkipped_other:
        '{{count}} unsupported files skipped — supported: PDF, DOC, DOCX, TXT, RTF.',
    },
    videoControls: {
      seek: 'Seek',
    },
    videoPlayPauseControls: {
      mute: 'Mute',
      pause: 'Pause',
      play: 'Play',
      unmute: 'Unmute',
    },
    weCouldnTLoadThe: "We couldn't load the selected project.",
    zoomControls: {
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
    },
  },
  projectDetailHeader: {
    editProjectDetail: 'Edit project detail',
    renameFailed: "We couldn't rename the project. Try again.",
    projectName: 'Project name',
    manageApprovalChains: 'Manage approval chains',
    projectActions: 'Project actions',
    projectMembers: '{{memberCount}} project members',
    share: 'Share',
  },
  projectDetailSidebar: {
    projectSelectorPopover: {
      loading: 'Loading...',
      noProjectsFound: 'No projects found',
      searchProjects: 'Search projects',
      untitledProject: 'Untitled project',
    },
  },
  projectFileUploadGuard: {
    resolution: {
      enterAFileName: 'Enter a file name',
      thisNameIsAlreadyTaken: 'This name is already taken',
    },
    uploadConflictModal: {
      cancel: 'Cancel',
      filesNeedADecision_one: '{{pending}} of {{count}} file need a decision before uploading.',
      filesNeedADecision_other: '{{pending}} of {{count}} files need a decision before uploading.',
      readyToUpload: 'Ready to upload',
      reviewUploads: 'Review uploads',
      uploadFiles_one: 'Upload {{count}} file',
      uploadFiles_other: 'Upload {{count}} files',
    },
    uploadFileRow: {
      newNameFor: 'New name for {{fileName}}',
      onlyAvailableForAFile: 'Only available for a file of the same type',
      ready: 'Ready',
      removeFile: 'Remove {{fileName}}',
      uploadAsNewVersion: 'Upload as new version',
      uploadsAsANewVersion: 'Uploads as a new version',
    },
  },
  projectFolder: {
    approvalUtils: {
      approvedOfTotal: '{{approved}}/{{total}} approved',
      noAssetsUploaded: 'No assets uploaded',
    },
    segmentedBar: {
      approvalProgress: 'Approval chain progress: {{progress}}',
    },
  },
  projectMember: {
    memberListItem: {
      owner: 'Owner',
      removeMember: 'Remove {{name}}',
    },
    roleSelector: {
      role: 'Role: {{role}}',
      noRole: 'No role',
      includesPermissionsYouLack: "Includes permissions you don't have",
      organizationAdminCanAssign: 'An Organization Admin can assign these roles.',
    },
  },
  projectOverview: {
    detailsSection: {
      productLine: 'Product line',
      audiences: 'Audiences',
      created: 'Created',
      dayCount_one: '{{count}} day',
      dayCount_other: '{{count}} days',
      details: 'Details',
      duration: 'Duration',
      edit: 'Edit',
      launch: 'Launch',
      market: 'Market',
      noAudiencesLinkedToThis: 'No audiences linked to this project.',
      owner: 'Owner',
      projectDetails: 'Project details',
      startDate: 'Start date',
      tags: 'Tags',
      title: 'Title',
      type: 'Type',
    },
    getStartedSoon: {
      assetsAwaitingApproval: 'Assets awaiting approval',
      newAssetsComments: 'New assets comments',
      totalArtifacts: 'Total artifacts',
      totalBriefs: 'Total briefs',
      artifacts: 'Artifacts',
      assets: 'Assets',
      briefs: 'Briefs',
      comments: 'Comments',
      snapshot: 'Snapshot',
    },
    quickStart: {
      addArtifactsToTheProject: 'Add artifacts to the project library',
      addTeamMembersSoThey: 'Add team members so they can contribute, review, and stay aligned.',
      agenticallyCreateABriefBased: 'Agentically create a brief based on the project context.',
      bringInKeyArtifactsFrom: 'Bring in key artifacts from your tools to enrich project context.',
      createABrief: 'Create a brief',
      inviteCollaborators: 'Invite collaborators',
      recommendedActions: 'Recommended actions',
      submitCreativeAssetsForTeam:
        'Submit creative assets for team review, feedback, and approval.',
      uploadAssetsForApprovals: 'Upload assets for approvals',
    },
  },
  projects: {
    about: {
      description:
        'Bring everything for a piece of work into one place, so your team can move from brief to delivery without losing the thread.',
      kickoffToDelivery: 'Take a piece of work from kickoff through delivery in a single space.',
      sharedStartingPoint:
        'Give your team a shared starting point and pick up right where anyone left off.',
      tiedToTheWork: 'Keep assets, briefs and tools artifacts tied to the work it belongs to.',
      title: 'About projects',
    },
    manageAndTrackProjectsBriefs:
      'Manage and track projects, briefs, and asset production in one place.',
    projects: 'Projects',
  },
  projectsList: {
    projectRowActions: {
      comingSoon: 'Coming soon',
      delete: 'Delete',
      duplicate: 'Duplicate',
      edit: 'Edit',
      projectActions: 'Project actions',
    },
    projectsTable: {
      actions: 'Actions',
      couldNotDeleteProject: 'Could not delete project.',
      created: 'Created',
      folders: 'Folders',
      lastActivity: 'Last activity',
      me: 'Me',
      name: 'Name',
      noProjectsFound: 'No projects found',
      owner: 'Owner',
      projectDeleted: 'Project deleted.',
      projectUpdated: '"{{projectTitle}}" project updated.',
      thisActionCannotBeUndone:
        'This action cannot be undone. The project will be permanently removed.',
      type: 'Type',
    },
    projectsToolbar: {
      allTypes: 'All types',
      createdNewestFirst: 'Created (newest first)',
      newProject: 'New project',
      search: 'Search',
      type: 'Type',
    },
    projectsViewState: {
      clearFilters: 'Clear filters',
      dataFailedToLoad: 'Data failed to load',
      manageAndTrackProjectsBriefs:
        'Manage and track projects, briefs, and asset production in one place.',
      newProject: 'New project',
      noMatchingProjects: 'No matching projects',
      noProjectsMatchYourCurrent: 'No projects match your current search or filters.',
      projects: 'Projects',
      somethingWentWrongLoadingYour:
        'Something went wrong loading your projects. Please try again.',
    },
  },
  projectSnapshot: {
    summary: 'Summary',
    useProjectSnapshot: {
      create: 'Create',
      startByCreatingYourFirst: 'Start by creating your first brief to kick off production.',
      youJustStarted: 'You just started {{title}}.',
    },
  },
  uploadQueue: {
    errorMessage: {
      networkErrorPleaseTryAgain: 'Network error, please try again',
      serverErrorPleaseTryAgainLater: 'Server error, please try again later',
      uploadFailed: 'Upload failed',
      uploadRejectedByServer: 'Upload rejected by server',
    },
    uploadItemRow: {
      cancelUpload: 'Cancel upload',
      dismissUpload: 'Dismiss upload',
      uploadComplete: 'Upload complete',
      uploadProgress: 'Upload progress {{progress}}%',
    },
    uploadToast: {
      uploading: 'Uploading {{activeCount}}',
      uploadsComplete: 'Uploads complete',
      uploadsFailed_one: '{{count}} upload failed',
      uploadsFailed_other: '{{count}} uploads failed',
    },
    uploadTrayPanel: {
      clearCompleted: 'Clear completed',
      folder: 'Folder',
      library: 'Library',
      noActiveUploads: 'No active uploads',
      uploads: 'Uploads',
      wizard: 'Wizard',
    },
  },
} as const;
